import styled from 'styled-components';

import { BaseStyleEnums } from '@nhl/nhl-breakaway-ui';

export const PrintFrame = styled.iframe`
    position: absolute;
    visibility: hidden;
    height: 1200px;
    width: ${BaseStyleEnums.ScreenWidthBreakpoints.extraLarge}px;
`;
